import Vue from 'vue'
export default {
  /* JS获取网页URL 所有参数 */
  getParams(url) {
    var theRequest = new Object();
    if (!url) {
      console.log(url);
      url = decodeURIComponent(location.href);
      console.log(url);
    }
    if (url.indexOf("?") !== -1) {
      var str = url.substr(url.indexOf("?") + 1) + "&";
      var strs = str.split("&");
      for (var i = 0; i < strs.length - 1; i++) {
        var key = strs[i].substring(0, strs[i].indexOf("="));
        var val = strs[i].substring(strs[i].indexOf("=") + 1);
        theRequest[key] = val;
      }
    }
    return theRequest;
  },
  getLocalStorage(key) {
    var value = localStorage.getItem(key)
    return value ? JSON.parse(value) : null
  },
  setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  removeLocalStorage(key) { localStorage.removeItem(key) },
  setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  getSessionStorage(key) {
    var value = sessionStorage.getItem(key)
    return value ? JSON.parse(value) : false
  },
  removeSessionStorage(key) { sessionStorage.removeItem(key) },
  /* 获取cookie */
  getCookie(name) {
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if (arr = document.cookie.match(reg)) { return unescape(arr[2]) } else { return false }
  },
  /* 判断是否是安卓 */
  isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,

  /* 判断是否是IOS */
  isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),

  /* JS获取CSS属性值 */
  getCurrentStyle(obj, attribute) {
    return obj.currentStyle ? obj.currentStyle[attribute] : document.defaultView.getComputedStyle(obj, false)[attribute]
  },

  /* JS获取网页URL参数 */
  getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2]); return null
  },
  getParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    if (window.location.hash.indexOf('?') < 0) {
      return null
    }
    const r = window.location.hash.split('?')[1].match(reg)
    if (r != null) {
      if (decodeURIComponent(r[2]) == "''") {
        return ''
      }
      return decodeURIComponent(r[2])
    }
    return null
  },
  /* 标准时间改yy-mm-dd格式 */
  formatDate() {
    const date = new Date()
    const year = date.getFullYear() + ''
    const month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return year + '-' + month + '-' + day
  }
}
export var ua = {
  isIPhone: /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent),
  isAndroid: /android/i.test(window.navigator.userAgent),
  isWeiXin: /MicroMessenger/i.test(window.navigator.userAgent),
  isIosApp: /zyb_ios/i.test(window.navigator.userAgent),
  isAndroidApp: /zyb_android/i.test(window.navigator.userAgent),
};
Vue.prototype.$ua = ua;



// WEBPACK FOOTER //
// ./src/axios/utils.js